import type { Locale } from '@spot/shared';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { TAB_PATHS } from '../../app/paths';
import { DEFAULT_CITY } from '../map/city';
import type { MapFilters as Filters } from '../map/filters';
import { MapFilters, WhenChips } from '../map/map-filters';
import { mapMemory } from '../map/memory';
import { EmptyState } from '../../components/ui/empty-state';
import { EventList } from './event-list';
import { useNearbyEvents } from './queries';

/** Поруч: the same filters as the map (shared), as a list. Search is reserved for later. */
export function NearbyTab({ locale }: { locale: Locale }) {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const [filters, setFiltersState] = useState<Filters>(mapMemory.filters);
	const setFilters = (next: Filters) => {
		mapMemory.filters = next;
		setFiltersState(next);
	};
	const query = useNearbyEvents(DEFAULT_CITY.slug, filters);

	return (
		<>
			<div className="-mx-4">
				<MapFilters value={filters} onChange={setFilters} />
				<WhenChips
					value={filters}
					onChange={setFilters}
					className="overflow-x-auto px-4 pb-2 [scrollbar-width:none]"
				/>
			</div>
			<EventList
				query={query}
				timeZone={DEFAULT_CITY.timezone}
				locale={locale}
				viewer={mapMemory.position}
				empty={
					<EmptyState
						emoji="🗺️"
						text={t('map.empty')}
						action={{
							label: t('activities.create'),
							onClick: () => void navigate(TAB_PATHS.create),
						}}
					/>
				}
			/>
		</>
	);
}
